import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import PageHero from "../components/common/PageHero";
import { Reveal } from "../components/common/Section";
import { INSIGHTS } from "../data/content";
import { useContent } from "../cms/ContentContext";

export default function Insights() {
  const { content } = useContent();
  const h = content.pages?.insights || {};
  const articles = content.insights?.length ? content.insights : INSIGHTS;
  useEffect(() => {
    document.title = "Insights | norse3";
  }, []);

  return (
    <div>
      <PageHero
        eyebrow={h.eyebrow || "Insights"}
        title={h.title || "Perspectives on runtime AI risk and oversight."}
        subtitle={h.subtitle || "How manipulation of AI systems actually works, why it matters for regulated firms, and what independent runtime controls change."}
      />

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-6 lg:grid-cols-2">
            {articles.map((a, i) => (
              <Reveal key={a.slug} delay={i * 80}>
                <Link
                  to={`/insights/${a.slug}`}
                  className="group block rounded-lg border border-white/10 bg-navy-900/60 p-7 lg:p-8 h-full hover:border-primary/30 transition-colors"
                >
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span className="rounded-full border border-primary/25 bg-primary/10 px-2.5 py-0.5 text-primary">{a.category}</span>
                    <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {a.readTime}</span>
                  </div>
                  <h2 className="mt-4 text-2xl font-bold text-foreground leading-snug group-hover:text-primary transition-colors">
                    {a.title}
                  </h2>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{a.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-primary">
                    Read the article <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
